import React, { useEffect, useRef } from "react";
import { Col, Modal, Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { newsSelector, pupSelector } from "../../../services/selector/index.";
import {
  IconArrowDown,
  IconArrowTop,
  IconDetail,
  IconEdit,
  IconLock,
  IconNext,
  IconPre,
  IconSave,
  IconSpin,
  IconXmark,
} from "../../../assets/icon";
import "../../../assets/style/modalStyle/configPageOne.scss";
import { useState } from "react";
import { useMemo } from "react";

import {
  deleteItemConfigNews,
  getDataFirstPage,
  saveConfigNews,
  setDataSaveConfig,
  setValueDeleteConfig,
} from "../../../services/slice/NewsSlice";
import TranslateText from "../TranslateText";
import { formatDate } from "../../../utils/functionCommon";
import BaseButton from "../Button/BaseButton";

const TableConfigPageOneNews = () => {
  const dispatch = useDispatch();
  const newsState = useSelector(newsSelector);
  const { dataBasePageOne, dataGhim, dataSaveConfig, refetchConfig } =
    newsState;
  // const { dataDelete, dataEdit } = statePup;
  useEffect(() => {
    dispatch(getDataFirstPage());
  }, []);
  useEffect(() => {
    if (refetchConfig) {
      dispatch(getDataFirstPage());
    } else return;
  }, [refetchConfig, dispatch]);
  const [dataGhimBackUp, setDataGhimBackUp] = useState([]);
  const [dataBaseBackUp, setDataBaseBackUp] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleSaveConfig = () => {
    dispatch(saveConfigNews(dataSaveConfig));
  };
  const dataSource = useMemo(() => {
    let result = [];
    let dataSaveConfig = [];
    const listGhim = [];
    dataGhimBackUp.map((item, index) => {
      listGhim.push(item.id);
      dataSaveConfig.push({ newsId: item.id, pin: item.pin, index: index + 1 });
      return result.push({
        ...item,
        timeCreate: formatDate(item.timeCreate),
        STT: index + 1,
        key: item.id,
        icon:
          !index && dataGhimBackUp.length <= 1
            ? "noIcon"
            : !index
            ? "down"
            : "up",
      });
    });
    dataBaseBackUp.map((item, index) => {
      dataSaveConfig.push({
        newsId: item.id,
        pin: item.pin,
        index: index + dataGhimBackUp.length + 1,
      });
      return result.push({
        ...item,
        timeCreate: formatDate(item.timeCreate),
        STT: index + dataGhimBackUp.length + 1,
        key: item.id,
        icon:
          index === 0
            ? "down"
            : index === dataBaseBackUp.length - 1
            ? "up"
            : "mix",
      });
    });
    dispatch(setDataSaveConfig(dataSaveConfig));
    setSelectedRowKeys(listGhim);
    return result;
  }, [dataBaseBackUp, dataGhimBackUp, dispatch]);
  const handleDelete = (value) => {
    dispatch(setValueDeleteConfig(value));
    dispatch(deleteItemConfigNews(value.id));
  };
  useEffect(() => {
    setDataGhimBackUp(dataGhim);
  }, [dataGhim]);
  useEffect(() => {
    setDataBaseBackUp(dataBasePageOne);
  }, [dataBasePageOne]);

  const handleMoveDown = (value, data, setData) => {
    let newData = [...data];
    const itemIndex = newData.findIndex((item) => item.id === value.id);
    if (itemIndex !== -1 && itemIndex < newData.length - 1) {
      [newData[itemIndex], newData[itemIndex + 1]] = [
        newData[itemIndex + 1],
        newData[itemIndex],
      ];
      newData = newData.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      setData(newData);
    }
  };
  const handleMoveUp = (value, data, setData) => {
    let newData = [...data];
    const itemIndex = newData.findIndex((item) => item.id === value.id);
    if (itemIndex > 0) {
      [newData[itemIndex], newData[itemIndex - 1]] = [
        newData[itemIndex - 1],
        newData[itemIndex],
      ];
      newData = newData.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      setData(newData);
    }
  };
  const columns = [
    {
      title: "Vị trí",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 200,
    },
    {
      title: <TranslateText text="Tiêu đề" />,
      dataIndex: "title",
      key: "title",
      className: "title collapseText pointer",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => (
        <>
          <Tooltip placement="topLeft" title={text}>
            {text}
          </Tooltip>
        </>
      ),
    },

    {
      title: <TranslateText text="Thời gian tạo" />,
      dataIndex: "timeCreate",
      key: "timeCreate",
      className: "centerCell",
    },

    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "evenSpace m10 btnAction",

      render: (text, record) => {
        return (
          <div
            className={
              record.icon === "mix" ? "btnDelete wrapperBtn" : "wrapperBtn "
            }
            style={{ minWidth: "90px" }}
          >
            <span
              className={
                record.icon === "mix"
                  ? "upDown pointer iconTbl"
                  : "pointer iconTbl"
              }
            >
              {dataSource.length <= 1 ? null : record.icon === "down" ? (
                <IconArrowDown
                  onClick={() => {
                    handleMoveDown(
                      record,
                      record.pin ? dataGhimBackUp : dataBaseBackUp,
                      record.pin ? setDataGhimBackUp : setDataBaseBackUp
                    );
                  }}
                />
              ) : record.icon === "up" ? (
                <IconArrowTop
                  onClick={() => {
                    handleMoveUp(
                      record,
                      record.pin ? dataGhimBackUp : dataBaseBackUp,
                      record.pin ? setDataGhimBackUp : setDataBaseBackUp
                    );
                  }}
                />
              ) : record.icon === "mix" ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <IconArrowTop
                    style={{ marginBottom: 5 }}
                    onClick={() => {
                      handleMoveUp(
                        record,
                        record.pin ? dataGhimBackUp : dataBaseBackUp,
                        record.pin ? setDataGhimBackUp : setDataBaseBackUp
                      );
                    }}
                  />
                  <IconArrowDown
                    onClick={() => {
                      handleMoveDown(
                        record,
                        record.pin ? dataGhimBackUp : dataBaseBackUp,
                        record.pin ? setDataGhimBackUp : setDataBaseBackUp
                      );
                    }}
                  />
                </div>
              ) : (
                <span></span>
              )}
            </span>
            <span
              className="pointer iconTbl"
              onClick={() => {
                handleDelete(record);
              }}
            >
              <Tooltip title="Xóa">
                <IconXmark />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    if (newSelectedRowKeys.length > 1) {
      Modal.error({
        className: "wrapperModalErrConfigBanner",
        centered: true,
        width: 590,
        title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
        content: (
          <>
            <p style={{ fontSize: 20 }}>Tối đa có 1 bài viết được ghim</p>
          </>
        ),
      });
      return;
    }
    let newDataGhim = [...dataGhimBackUp];
    let newDatabase = [...dataBaseBackUp];
    let differentElements = selectedRowKeys
      .concat(newSelectedRowKeys)
      .filter(function (element, index, self) {
        return (
          self.indexOf(element) === index &&
          !(
            selectedRowKeys.includes(element) &&
            newSelectedRowKeys.includes(element)
          )
        );
      });
    if (newDataGhim.find((item) => item.id === differentElements[0])) {
      newDatabase.push({
        ...newDataGhim.find((item) => item.id === differentElements[0]),
        pin: 0,
      });
      newDataGhim = newDataGhim.filter(
        (item) => item.id !== differentElements[0]
      );
      setDataBaseBackUp(newDatabase);
      setDataGhimBackUp(newDataGhim);
    } else {
      newDataGhim.push({
        ...newDatabase.find((item) => item.id === differentElements[0]),
        pin: 1,
      });
      newDatabase = newDatabase.filter(
        (item) => item.id !== differentElements[0]
      );
      setDataBaseBackUp(newDatabase);
      setDataGhimBackUp(newDataGhim);
    }
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    columnTitle: "Ghim",
    width: 200,
    onChange: onSelectChange,
  };
  return (
    <>
      <Row>
        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            content={`Lưu`}
            width={120}
            typeBtn="btnOrange"
            icon={<IconSave />}
            handleClick={handleSaveConfig}
          />
        </Col>
      </Row>
      <Row style={{ width: "100%" }}>
        <Table
          rowSelection={rowSelection}
          className="wrapperTblConfigPageOne"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={false}
        />
      </Row>
    </>
  );
};

export default TableConfigPageOneNews;
